import { render } from "./FormNumberInspection.vue?vue&type=template&id=35f5dde9"
import script from "./FormNumberInspection.vue?vue&type=script&lang=js"
export * from "./FormNumberInspection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__